import React from 'react';
import useBranchOrders from '@ubeya/shared/hooks/account/useBranchOrders';
import OrdersSummaryModal from './OrdersSummaryModal';

const OrdersSummaryByBranchWrapper = ({ onClose, stats }) => {
  const { orders } = useBranchOrders();

  return <OrdersSummaryModal onClose={onClose} orders={orders} stats={stats} />;
};

export default OrdersSummaryByBranchWrapper;
